export const ServiceTypes = {
  DROPOFF_AND_COLLECTION: 'dropoff_collection',
  DROPOFF_ONLY: 'dropoff',
  COLLECTION_ONLY: 'collection',
};



// WEBPACK FOOTER //
// ./src/utils/constants/clients.js